var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66671 2.66536C4.66671 1.92898 5.26366 1.33203 6.00004 1.33203H10C10.7364 1.33203 11.3334 1.92898 11.3334 2.66536V3.9987H12.6598C12.6639 3.99866 12.6681 3.99866 12.6722 3.9987H14C14.3682 3.9987 14.6667 4.29717 14.6667 4.66536C14.6667 5.03355 14.3682 5.33203 14 5.33203H13.2875L12.7092 13.427C12.6594 14.1248 12.0788 14.6654 11.3793 14.6654H4.62079C3.92127 14.6654 3.34068 14.1248 3.29084 13.427L2.71263 5.33203H2.00004C1.63185 5.33203 1.33337 5.03355 1.33337 4.66536C1.33337 4.29717 1.63185 3.9987 2.00004 3.9987H3.32787C3.33201 3.99866 3.33613 3.99866 3.34025 3.9987H4.66671V2.66536ZM6.00004 3.9987H10V2.66536H6.00004V3.9987ZM4.04936 5.33203L4.62079 13.332H11.3793L11.9507 5.33203H4.04936ZM6.66671 6.66536C7.0349 6.66536 7.33337 6.96384 7.33337 7.33203V11.332C7.33337 11.7002 7.0349 11.9987 6.66671 11.9987C6.29852 11.9987 6.00004 11.7002 6.00004 11.332V7.33203C6.00004 6.96384 6.29852 6.66536 6.66671 6.66536ZM9.33337 6.66536C9.70156 6.66536 10 6.96384 10 7.33203V11.332C10 11.7002 9.70156 11.9987 9.33337 11.9987C8.96518 11.9987 8.66671 11.7002 8.66671 11.332V7.33203C8.66671 6.96384 8.96518 6.66536 9.33337 6.66536Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.a451dfba437ef599c388466e54298d0c.svg";
export { ForwardRef as ReactComponent };